import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import userIcon from "assets/frontend/images/user.png";
import axiosConfig from "config/axiosConfig";
import UrlImage from "config/UrlImage";

function CardContentProject() {
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState([]);

  useEffect(() => {
    let isMounted = true;

    axiosConfig.get(`/api/getProjects`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setProject(res.data.project);
          setLoading(false);
        }
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const countData = project.length
  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-grow text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  } else {
    if (countData < 1) {
      return (
        <div className="col-md-12 py-5 px-5 text-center">
          <h4>Belum ada data project yang di upload</h4>
        </div>
      )
    } else {
      var showProjectList = "";
      showProjectList = project.map((item) => {
        return (
          // <div className="col-12 col-md-4 col-lg-3">
          //   <div className="card" key={item.index}>
          //     <div className="card-body">
          //       <Link to="/detail" className="component-content d-block">
          //         <div className="content-thumbnail">
          //           <div className="content-image">
          //             <Link to={`/project/detail/${item.slug}`}>
          //               <img
          //                 src={`${UrlImage}/${item.image}`}
          //                 className="img-fluid"
          //               />
          //             </Link>
          //           </div>
          //         </div>
          //         <div className="content-title">
          //           <Link to={`/project/detail/${item.slug}`}>{item.name}</Link>
          //         </div>
          //       </Link>
          //       <div className="divider"></div>
          //       <div className="author">
          //         <div className="author-profile">
          //           <img
          //             src={userIcon}
          //             className="profile-picture rounded-circle"
          //             alt=""
          //           />
          //           <p className="author-name">Author</p>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div>

          <section id="portfolio" class="portfolio" key={item.index}>
            <div className="container">
              <div className="section-title">
                <h2>Portfolio</h2>
                <p>
                  Magnam dolores commodi suscipit. Necessitatibus eius consequatur
                  ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam
                  quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea.
                  Quia fugiat sit in iste officiis commodi quidem hic quas.
                </p>
              </div>

              <div className="row">
                <div className="col-lg-12 d-flex justify-content-center">
                  <ul id="portfolio-flters">
                    <li data-filter="*" className="filter-active">
                      All
                    </li>
                    <li data-filter=".filter-app">App</li>
                    <li data-filter=".filter-card">Card</li>
                    <li data-filter=".filter-web">Web</li>
                  </ul>
                </div>
              </div>

              <div className="row portfolio-container">
                <div className="col-lg-4 col-md-6 portfolio-item filter-app">
                  <div className="portfolio-wrap">
                    <img
                      src={`${UrlImage}/${item.image}`}
                      className="img-fluid"
                      alt=""
                    />
                    <div className="portfolio-info">
                      <h4>App 1</h4>
                      <p>App</p>
                      <div className="portfolio-links">
                        <a
                          href={`${UrlImage}/${item.image}`}
                          data-gallery="portfolioGallery"
                          className="portfolio-lightbox"
                          title="App 1"
                        >
                          <i className="bx bx-plus"></i>
                        </a>
                        <Link
                          to={`/project/detail/${item.slug}`}
                          title="More Details"
                        >{item.name}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      });
    }

  }

  return <div className="row">{showProjectList}</div>;
}

export default CardContentProject;

/**
 * card content with Project with pagination
 */

// import axiosConfig from 'config/axiosConfig';
// import UrlImage from 'config/UrlImage';
// import userIcon from "assets/frontend/images/user.png";
// import React, { useEffect, useState } from 'react'
// import ReactPaginate from 'react-paginate';
// import { Link } from 'react-router-dom';

// function CardContentProject() {

//     const [offset, setOffset] = useState(0)
//     const [project, setData] = useState([])
//     const [perPage] = useState(10);
//     const [pageCount, setPageCount] = useState(0)

//     const getData = async () => {
//         const res = await axiosConfig.get(`/api/getProjects`)

//         const project = res.data.project;
//         const slice = project.slice(offset, offset + perPage)

//         const postData = slice.map(item =>
//             <div className="col-12 col-md-4 col-lg-3">
//                 <div className="card" key={item.id}>
//                     <div className="card-body">
//                         <Link to="/detail" className="component-content d-block">
//                             <div className="content-thumbnail">
//                                 <div className="content-image">
//                                     <Link to={`/project/detail/${item.slug}`}>
//                                         <img src={`${UrlImage}/${item.image}`} className="img-fluid" />
//                                     </Link>
//                                 </div>
//                             </div>
//                             <div className="content-title">
//                                 <Link to={`/project/detail/${item.slug}`}>
//                                     {item.name}
//                                 </Link>
//                             </div>
//                         </Link>
//                         <div className="divider"></div>
//                         <div className="author">
//                             <div className="author-profile">
//                                 <img
//                                     src={userIcon}
//                                     className="profile-picture rounded-circle"
//                                     alt=""
//                                 />
//                                 <p className="author-name">Author</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//         setData(postData)
//         setPageCount(Math.ceil(project.length / perPage))
//     }

//     const handlePageClick = (e) => {
//         const selectedPage = e.selected;
//         setOffset(selectedPage + 1)
//     }

//     useEffect(() => {
//         getData()
//     }, [offset])

//     return (
//         <div className="row">
//             {project}
//             <ReactPaginate
//                 previousLabel={"prev"}
//                 nextLabel={"next"}
//                 breakLabel={"..."}
//                 breakClassName={"break-me"}
//                 pageCount={pageCount}
//                 marginPagesDisplayed={2}
//                 pageRangeDisplayed={5}
//                 onPageChange={handlePageClick}
//                 containerClassName={"pagination"}
//                 subContainerClassName={"pages pagination"}
//                 activeClassName={"active"}
//             />
//         </div>
//     )
// }

// export default CardContentProject

/**
 * card content with Project with pagination
 */
